export { FilterComponent } from './filter.component';


// WEBPACK FOOTER //
// ./src/app/common/filter/index.ts